<template>
    <div class="accordion--card">
        <button
            class="accordion--btn"
            data-toggle="collapse"
            :class="{ collapsed: isCollapsed }"
            :data-target="'#'+collapseId"
            :aria-expanded="!isCollapsed"
            :aria-controls="collapseId"
        >
            {{ title }}
        </button>
        <div :id="collapseId"  :class="{ collapse: isCollapsed }" :aria-labelledby="'heading-' + collapseId" data-parent="#accordion">
            <div class="mt-3">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccordionCard',
    props: {
        title: String,
        collapseId: String,
        isCollapsed: Boolean,
    },
};

</script>


<style scoped>

</style>
